import { gql } from '@apollo/client';

export const updateGoalPlansMutation = gql`
  mutation UpdateGoalPlans($goalIdsToActivate: [String!]!, $goalIdsToDeactivate: [String!]!, $goalPlans: [GoalPlanInput!]!) {
    updateGoalPlans(data: { goalIdsToActivate: $goalIdsToActivate, goalIdsToDeactivate: $goalIdsToDeactivate, goalPlans: $goalPlans }) {
      user {
        id
        goalCompletion
      }
      goals {
        id
        completedXP
        targetLevel
        targetPlan
        active
      }
    }
  }
`; 